// extracted by mini-css-extract-plugin
export var gif = "_hv-0";